import { render } from "./MainContent.vue?vue&type=template&id=4d624092&scoped=true&ts=true"
import script from "./MainContent.vue?vue&type=script&lang=ts"
export * from "./MainContent.vue?vue&type=script&lang=ts"

import "./MainContent.vue?vue&type=style&index=0&id=4d624092&lang=less&scoped=true"

import exportComponent from "C:\\Users\\adavi\\Documents\\CosmicDS\\minids\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d624092"]])

export default __exports__